// import './wdyr';

import React from 'react';

import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './theme.less'
import './theme-custom.less'
import 'font-awesome/css/font-awesome.min.css';
import i18n from './i18n';
import { I18nextProvider } from 'react-i18next';

const container = document.getElementById('root');
const root = createRoot(container); 
root.render(<I18nextProvider i18n={i18n} defaultNS={'translation'}><App /></I18nextProvider>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();